// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2BkNY","info":"UpdateTermsInfo_info__3oq84"};